
import React, { Component } from "react";
import { Link } from "gatsby";

import tickpink from "../images/tick-pink.svg"
import tickyellow from "../images/tick-yellow.svg"
import tickgreen from "../images/tick-green.svg"
import tickorange from "../images/tick-orange.svg"

class  OurResponsibility extends Component {
  constructor() {
    super();
    this.state = {
     };
}


render(){
  return(
    <section className="commitment-sec"> 
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title wow fadeInUp" data-wow-duration="1s" data-wow-delay=".1s">
                                <h2>Our Responsibility & Commitment</h2>
                                <p>We are 100% committed to the success of our patients, doctors and partners</p>
                            </div>
                            <div className="commitment-inner">
                                <div className="row">
                                    <div className="col-md-3 col-6">
                                        <div className="commitment-box wow fadeInUp" data-wow-duration="1s" data-wow-delay=".1s">
                                            <div className="image-holder">
                                                <img src={tickpink} alt="" />
                                            </div>
                                            <div className="text-box">
                                                <h3>Patient <br/> Success</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-6">
                                        <div className="commitment-box wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">
                                            <div className="image-holder">
                                                <img src={tickyellow} alt="" />
                                            </div>
                                            <div className="text-box">
                                                <h3>Patient  <br/> Safety</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-6">
                                        <div className="commitment-box wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
                                            <div className="image-holder">
                                                <img src={tickgreen} alt="" />
                                            </div>
                                            <div className="text-box">
                                                <h3>Reliability  <br/> Technology</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-6">
                                        <div className="commitment-box wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                                            <div className="image-holder">
                                                <img src={tickorange} alt="" />
                                            </div>
                                            <div className="text-box">
                                                <h3>24x7  <br/>
                                                    Care</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
  )
}

}

export default OurResponsibility;

  
  

  



  

 
  
 